import { Container } from "reactstrap";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { SkeletonTheme } from "react-loading-skeleton";
import Customers from "../Customers";
import { useTranslation } from "react-i18next";

const Tenants = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("tenants.pageTitle") });

  return (
    <>
      <SkeletonTheme baseColor="#F0F4F6" highlightColor="#e9ebec">
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title={t("tenants.pageTitle")} hideCrumbs={true} />
            <Customers />
          </Container>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default Tenants;
